<template>
  <div>
    <div
      class="modal fade"
      ref="reviewModal"
      id="reviewModal"
      tabindex="-1"
      aria-labelledby="reviewModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5" id="reviewModalLabel">
              {{ 'Leave a review' | translate }}
            </h1>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div v-if="finished" class="text-center">
              <h2>{{'Thank you!' | translate}}</h2>
            </div>
            <div v-else>
              <div class="text-center mb-3 fw-bold h6">
                {{ 'Would you recommend this product to others?' | translate }}
              </div>
              <div class="d-flex justify-content-around">
                <div class="text-center">
                  <button
                    @click="rating = 10"
                    class="btn"
                    :class="[
                      rating === 10 ? 'border border-3' : '',
                    ]"
                  >
                    <i class="far fa-smile fa-3x"></i>
                  </button>

                  <div></div>
                </div>
                <div class="text-center">
                  <button
                    @click="rating = 5"
                    class="btn"
                    :class="[
                      rating === 5 ? 'border border-3' : '',
                    ]"
                  >
                    <i class="far fa-meh fa-3x"></i>
                  </button>
                  <div>
                  </div>
                </div>
                <div class="text-center">
                  <button
                    @click="rating = 1"
                    class="btn"
                    :class="[
                      rating === 1 ? 'border border-3' : '',
                    ]"
                  >
                    <i class="far fa-frown fa-3x"></i>
                  </button>
                  <div></div>
                </div>
              </div>

              <div class="mt-4" v-if="rating">
                <div class="text-center mb-3 fw-bold h6">
                  {{ 'Why did you choose that answer?' | translate }}
                </div>
                <textarea class="form-control" v-model="review"></textarea>
              </div>
            </div>
            <div class="modal-footer" v-if="rating && !finished">
              <button
                @click.prevent="submit"
                type="button"
                class="btn btn-dark"
              >
                {{ 'Submit' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  data: () => ({
    modal: null,
    rating: null,
    review: null,
    finished: false,
  }),
  mounted() {
    this.modal = new bootstrap.Modal(this.$refs.reviewModal)
  },
  methods: {
    close() {
      this.modal.hide()
    },
    submit() {
      axios
        .post(`/${this.course.id}/review`, {
          rating: this.rating,
          review: this.review,
        })
        .then(() => {
          this.finished = true
        })
        .catch(error => {
          let status = _.get(error, 'response.status')

          if (status === 403) {
            this.close()
          }
        })
    },
  },
  computed: {
    course() {
      return this.$store.state.course
    },
  },
}
</script>
